var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 18,
    rx: 2,
    fill: "url(#paint0_linear_3115_53260)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25716 6.5L3 11.4936H5.70214L6.03713 10.6974H6.80283L7.13782 11.4936H10.1121V10.8859L10.3771 11.4936H11.9157L12.1807 10.8731V11.4936H18.3664L19.1186 10.7181L19.8229 11.4936L23 11.5L20.7357 9.01073L23 6.5H19.8722L19.14 7.26118L18.4579 6.5H11.7286L11.1508 7.78889L10.5594 6.5H7.86286V7.087L7.5629 6.5C7.5629 6.5 5.25716 6.5 5.25716 6.5ZM5.78001 7.20909H7.09716L8.59433 10.5953V7.20909H10.0372L11.1936 9.63696L12.2594 7.20909H13.695V10.7923H12.8215L12.8143 7.98452L11.5407 10.7923H10.7593L9.47857 7.98452V10.7923H7.68143L7.34072 9.989H5.50002L5.16002 10.7916H4.19713L5.78001 7.20909ZM14.4943 7.20909H18.0464L19.1329 8.3823L20.2543 7.20909H21.3407L19.69 9.01002L21.3407 10.7902H20.205L19.1186 9.60336L17.9914 10.7902H14.4943V7.20909ZM6.42076 7.81536L5.81432 9.24639H7.0265L6.42076 7.81536ZM15.3715 7.951V8.60512H17.3093V9.33418H15.3715V10.0483H17.545L18.555 8.99648L17.5879 7.95038H15.3715V7.951Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3115_53260",
    x1: 1.5,
    y1: 17,
    x2: 25,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F72CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F72CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.7e6afac7261fa8c1408233e020b87740.svg";
export { ForwardRef as ReactComponent };